module.exports = __webpack_public_path__ + "img/measurement.c06b41a0.svg";